import React from 'react';
import withAuthorization from 'components/Session/withAuthorization';
import { Typography } from '@material-ui/core';
import SectionFooter from 'views/SectionFooter';
import GuideHeader from 'components/GuideHeader';
import GuideContent from 'components/GuideContent';
import GuideSection from 'components/GuideSection';
import DownloadGuideButton from 'views/Principles/DownloadGuideButton';

const GoalSetting = () => {
  return (
    <>
      <GuideHeader
        name="Goal Setting"
        text="This is the guide to maximizing your potential. Here you will be given the tools to create structure to promote your success."
      />
      <GuideContent>
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            WELCOME TO BODYF1RST
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Most people take the wrong approach to fitness, focusing mainly on exercise and nutrition when really
            starting by connecting with a strong spirit and mindset is the most important. BodyF1RST Core 4 Wellness
            Program focuses around the Core 4 Principles I believe will lead you to Total Optimization - Spirit,
            Mindset, Nutrition, Exercise. In this order.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Spirit</strong> is your ability to understand right from wrong (your highest outcome).
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Mindset</strong> is your ability to think through problems logically.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Nutrition</strong> is key to fuel your body with the nutrients required for physical and mental
            health.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Exercise</strong> is key to promote physical, mental health and overall wellbeing.
          </Typography>

          <Typography variant="body1" gutterBottom paragraph>
            The stronger your commitment, the sooner you will achieve the lifestyle you desire! Scheduling your “me
            time” to focus on your spirit, mindset, nutrition and exercise is crucial for your success. Be willing to
            step out of your comfort zone and try a new way. Direct your thoughts and be open to a new way of thinking
            by allowing for new ideas and solutions. Challenges have solutions and sometimes they are crowded with self
            limitations so it is important to focus your mind on positive outcomes. Discovering your ultimate desires
            and writing down your goals is essential. This will allow you to set big goals that are obtainable. The goal
            setting process is a prerequisite for your happiness. Studies have shown that people who make progress
            toward meaningful goals live more purposeful and satisfying lives. Goals give us directions. They put a
            powerful force into play on a universal, conscious, and subconscious level. I once heard to achieve big
            rewards expect big challenges! To achieve small rewards expect small challenges. Think BIG and be prepared
            to be challenged.
          </Typography>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom paragraph>
            GOAL SETTING GUIDELINES
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            1. <strong>What?</strong> Clearly define what it is you desire. What benefits of achieving your goal will it
            bring.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            2. <strong>Why?</strong> Know your ['WHY' for every goal. Does your goal resonate with you? How will
            achieving this goal make you feel?
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            3. <strong>How?</strong> Clearly defined steps. Not planning what you want to achieve or how you want to
            live you are making a decision to accept what you have achieved and the way you are living.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            4. <strong>When?</strong> Being clear about when you are going to do it will lead you to completing your
            goals. Plan ahead. Add your action steps to your calendar. Take massive action. Consistency is key to
            achieving your goals.
          </Typography>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom paragraph>
            KEY POINTS
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Identify</strong> things that may stand in the way of you accomplishing your goal. (example: An
            obstacle may be finding the time to workout in your busy schedule.)
          </Typography>

          <Typography variant="body1" gutterBottom paragraph>
            <strong>Notice what’s working</strong> and what’s not working, know when to change your approach.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Identify obstacles</strong> that may stand in the way of you accomplishing your goal. (example: An
            obstacle may be finding the time to workout in your busy schedule.)
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Remember People, Places and Things.</strong> The people you hang out with, the places you go and the
            things you do have played a role in getting you to your current situation. So to be successful and reach
            your goals you will need to make sacrifices and overcome your obstacles.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Focus</strong> on 1 to 3 goals per principle.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Don’t compare yourself to others.</strong> You are unique in your own way!
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Utilize your resources.</strong> Within each principle there are tools and apps that can help you
            along your path.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Prioritize your goals</strong> in the order of God, Family, Health and Business (GFHB). In each of
            the Core 4 Principles of Total Optimization, your goals should be placed in priority based on GFHB. When you
            need to determine what to work on first always refer to the GFHB order.
          </Typography>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom paragraph>
            HELPFUL RESOURCES
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Self Journal by Best Self</strong>. Use this journal to plan your day, be accountable for each hour
            of your day, to write out your gratitude list and to reflect back on.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>Create a Vision Board</strong> of all your goals. Use pictures or words that keep you focused on
            your goals and show your end results of that goal. Hang your vision board up in a place that you will see it
            daily.
          </Typography>
        </GuideSection>
        <DownloadGuideButton storagePath="guides/goal-setting-guide.pdf" type="Goal Setting" />
      </GuideContent>
      <SectionFooter />
    </>
  );
};

export default withAuthorization()(GoalSetting);
